var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 70,
    height: 56.166656494140625,
    viewBox: "0 0 70 56.166656494140625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg0_1_545"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6D34",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.28571581840515%",
    stopColor: "#841600",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.9923,4.25899C16.8098,3.86436,16.7153,3.43478,16.7153,3C16.7153,1.34315,18.0585,0,19.7153,0C20.8848,0,21.9476,0.679542,22.4384,1.74101Q28.5139,14.8817,28.5139,28.0833Q28.5139,41.2834,22.4398,54.4226L22.4384,54.4257C21.9476,55.4871,20.8848,56.1667,19.7153,56.1667C18.0585,56.1667,16.7153,54.8235,16.7153,53.1667C16.7153,52.7319,16.8098,52.3023,16.9923,51.9077Q22.5139,39.965,22.5139,28.0833Q22.5139,16.2016,16.9923,4.25899ZM34.7916,0C33.1348,0,31.7916,1.34315,31.7916,3L31.7916,53.1667C31.7916,54.8235,33.1348,56.1667,34.7916,56.1667C36.4485,56.1667,37.7916,54.8235,37.7916,53.1667L37.7916,3C37.7916,1.34315,36.4485,0,34.7916,0ZM52.5911,4.25899C52.7735,3.86436,52.868,3.43478,52.868,3C52.868,1.34315,51.5249,0,49.868,0C48.6986,0,47.6358,0.679542,47.145,1.74101Q41.0694,14.8817,41.0694,28.0833Q41.0694,41.2834,47.1436,54.4226L47.145,54.4257C47.6358,55.4871,48.6986,56.1667,49.868,56.1667C51.5249,56.1667,52.868,54.8235,52.868,53.1667C52.868,52.7319,52.7735,52.3023,52.5911,51.9077Q47.0694,39.965,47.0694,28.0833Q47.0694,16.2016,52.5911,4.25899ZM10.2558,19.3108C9.59646,18.7309,8.56756,19.2267,8.60338,20.1069L8.80933,25.1667L3.47917,25.1667C1.55768,25.1667,0,26.7337,0,28.6667C0,30.5997,1.55768,32.1667,3.47917,32.1667L9.09425,32.1667L9.26108,36.2654C9.29511,37.1015,10.2718,37.5305,10.9045,36.9873L19.8684,29.2909C20.3311,28.8936,20.3353,28.1757,19.8773,27.7729L10.2558,19.3108ZM59.7442,19.3108C60.4035,18.7309,61.4324,19.2267,61.3966,20.1069L61.1907,25.1667L66.5208,25.1667C68.4423,25.1667,70,26.7337,70,28.6667C70,30.5997,68.4423,32.1667,66.5208,32.1667L60.9057,32.1667L60.7389,36.2654C60.7049,37.1015,59.7282,37.5305,59.0955,36.9873L50.1316,29.2909C49.6689,28.8936,49.6647,28.1757,50.1227,27.7729L59.7442,19.3108Z",
    fillRule: "evenodd",
    fill: "url(#master_svg0_1_545)",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpt2);
export default __webpack_public_path__ + "static/media/opt2.a783e1422ec8949d1b9dd81c560472e9.svg";
export { ForwardRef as ReactComponent };